import React, { Component } from 'react';
import { Glyphicon, FormGroup, FormControl, ControlLabel, Panel, Button } from "react-bootstrap";
import UserProfile from './UserProfile';
import Input from './UI/Input/Input';
import "./Registry.css";
import AlertElement from './UI/Alert/Alert';
import axios from 'axios';

export class Registry extends Component {
    displayName = Registry.name

    constructor(props) {
        super(props);
        this.state = {
            forecasts: [],
            loading: false,
            showerror: false,
            errorheader: '',
            errortext: '',
            formsconfig:
            {
                show: false,
                type: 0,
            },
            objform: {
                id: {
                    elementType: 'hidden',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Id'
                    },
                    value: '0',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: true
                },
                matricola: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Matricola',
                        maxlength: '20'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: true
                },
                ragioneSociale: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Ragione Sociale',
                        maxlength: '100'
                    },
                    value: '',
                    validation: {
                        required: true,
                        minLength: 5,
                        maxLength: 5,
                        isNumeric: true
                    },
                    valid: false,
                    touched: false
                },
                piva: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Partita IVA',
                        maxlength: '11'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                ibanSocieta: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'IBAN',
                        maxlength: '27'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                bicSwift: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'BIC\Swift',
                        maxlength: '11'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                cittaSocieta: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Citta',
                        maxlength: '40'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                indirizzoSocieta: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Indirizzo',
                        maxlength: '150'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                nCivicoSocieta: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Numero Civico',
                        maxlength: '30'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                capSocieta: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'CAP',
                        maxlength: '5'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                }
            },
            filterForm: {
                matricola: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'numeric',
                        placeholder: 'Matricola:'
                    },
                    value: '',
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                ragioneSociale: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'numeric',
                        placeholder: 'RagioneSociale:'
                    },
                    value: '',
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
            },
            formIsValid: false,
        };
        this.filterCustom = this.filterCustom.bind(this);
        //this.refresh();
    }
    refresh() {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token
        })
        axios.post('api/Registry/List', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState({ forecasts: respose.data, loading: false });
            })
            .catch(data => {
            });
    }
    ModificaFetch = event => {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Content:
            {
                Id: this.state.objform.id.value,
                IbanSocieta: this.state.objform.ibanSocieta.value,
                PartitaIVA: this.state.objform.piva.value,
                BicSwift: this.state.objform.bicSwift.value,
                Matricola: this.state.objform.matricola.value,
                CittaSocieta: this.state.objform.cittaSocieta.value,
                IndirizzoSocieta: this.state.objform.indirizzoSocieta.value,
                NCivicoSocieta: this.state.objform.nCivicoSocieta.value,
                RagioneSocialeSocieta: this.state.objform.ragioneSociale.value,
                capSocieta: this.state.obj.cap.value
            }
        })
        axios.post('api/Registry/Modify', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState(prevState => {
                    console.log(respose.data);
                    if (respose.data != '' && respose.data != 'OK') {
                        this.state.showerror = true;
                        this.state.errorheader = 'Errore modifica:';
                        this.state.errortext = respose.data;
                    }
                    let updatingstate = Object.assign({}, prevState);
                    updatingstate.formsconfig.show = false;
                    return { updatingstate };
                })
                //this.refresh();
            })
            .catch(data => {
                this.state.showerror = true;
                this.state.errorheader = 'Errore modify:';
                this.state.errortext = data.respose;
            });
    }
    InserisciFetch = event => {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Content:
            {
                Id: this.state.objform.id.value,
                IbanSocieta: this.state.objform.ibanSocieta.value,
                PartitaIVA: this.state.objform.piva.value,
                BicSwift: this.state.objform.bicSwift.value,
                Matricola: this.state.objform.matricola.value,
                CittaSocieta: this.state.objform.cittaSocieta.value,
                IndirizzoSocieta: this.state.objform.indirizzoSocieta.value,
                NCivicoSocieta: this.state.objform.nCivicoSocieta.value,
                RagioneSocialeSocieta: this.state.objform.ragioneSociale.value,
                capSocieta: this.state.objform.capSocieta.value
            }
        })
        axios.post('api/Registry/Insert', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                if (respose.data != '' && respose.data != 'OK') {
                    this.state.showerror = true;
                    this.state.errorheader = 'Errore inserimento:';
                    this.state.errortext = respose.data;
                }
                this.setState(prevState => {
                    let updatingstate = Object.assign({}, prevState);
                    updatingstate.formsconfig.show = false;
                    return { updatingstate };
                })
                //this.refresh();
            })
            .catch(data => {
                this.state.showerror = true;
                this.state.errorheader = 'Errore inserimento:';
                this.state.errortext = data.respose;
            });
    }
    EliminaFetch = event => {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Content:
            {
                Id: this.state.objform.id.value
            }
        })
        axios.post('api/Registry/Delete', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState(prevState => {
                    let updatingstate = Object.assign({}, prevState);
                    updatingstate.formsconfig.show = false;
                    return { updatingstate };
                })
                //this.refresh();
            })
            .catch(data => {
                this.state.showerror = true;
                this.state.errorheader = 'Errore cancellazione';
                this.state.errortext = '';
            });
    }
    Nuovo = event => {
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.objform.matricola.value = '';
            updatingstate.objform.ragioneSociale.value = '';
            updatingstate.objform.piva.value = '';
            updatingstate.objform.ibanSocieta.value = '';
            updatingstate.objform.bicSwift.value = '';
            updatingstate.objform.cittaSocieta.value = '';
            updatingstate.objform.indirizzoSocieta.value = '';
            updatingstate.objform.nCivicoSocieta.value = '';
            updatingstate.objform.capSocieta.value = '';
            updatingstate.formsconfig.show = true;
            updatingstate.formsconfig.type = 1;
            return { updatingstate };
        })
    }
    Modifica = (event, modifing) => {
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.objform.id.value = modifing.id;
            updatingstate.objform.matricola.value = modifing.matricola;
            updatingstate.objform.ragioneSociale.value = modifing.ragioneSocialeSocieta;
            updatingstate.objform.piva.value = modifing.partitaIVA;
            updatingstate.objform.ibanSocieta.value = modifing.ibanSocieta;
            updatingstate.objform.bicSwift.value = modifing.bicSwift;
            updatingstate.objform.cittaSocieta.value = modifing.cittaSocieta;
            updatingstate.objform.indirizzoSocieta.value = modifing.indirizzoSocieta;
            updatingstate.objform.nCivicoSocieta.value = modifing.nCivicoSocieta;
            updatingstate.objform.capSocieta.value = modifing.capSocieta;
            updatingstate.formsconfig.show = true;
            updatingstate.formsconfig.type = 2;
            return { updatingstate };
        })
    }
    Elimina = (event, deleting) => {
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.objform.id.value = deleting.id;
            updatingstate.objform.matricola.value = deleting.matricola;
            updatingstate.objform.ragioneSociale.value = deleting.ragioneSocialeSocieta;
            updatingstate.objform.piva.value = deleting.partitaIVA;
            updatingstate.objform.ibanSocieta.value = deleting.ibanSocieta;
            updatingstate.objform.bicSwift.value = deleting.bicSwift;
            updatingstate.objform.cittaSocieta.value = deleting.cittaSocieta;
            updatingstate.objform.indirizzoSocieta.value = deleting.indirizzoSocieta;
            updatingstate.objform.nCivicoSocieta.value = deleting.nCivicoSocieta;
            updatingstate.objform.capSocieta.value = deleting.capSocieta;
            updatingstate.formsconfig.show = true;
            updatingstate.formsconfig.type = 3;
            return { updatingstate };
        })
    }
    Chiudi = event => {
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.formsconfig.show = false;
            return { updatingstate };
        })
    }
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }
    filterFormChangeHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.filterForm
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ filterForm: updatedForm });
        //this.forceRender();
    }
    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.objform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ objform: updatedForm, formIsValid: formIsValid });
        console.log(inputIdentifier);
        if (inputIdentifier === "matricola") {
            let data = JSON.stringify({
                Token: UserProfile.getLogin().token,
                Content:
                {
                    Matricola: updatedFormElement.value
                }
            })
            axios.post('api/Registry/Exist', data, { headers: { 'Content-Type': 'application/json' } })
                .then(respose => {
                    updatedFormElement.valid = !respose.data;
                    console.log(updatedFormElement);
                    this.setState({ objform: updatedForm, formIsValid: formIsValid });
                })
                .catch(data => {
                    this.setState({ objform: updatedForm, formIsValid: formIsValid });
                })
        }
    }
    clickdismiss() {
        this.state.showerror = false;
        //this.forceRender();
    }
    forceRender = event => {
        this.setState({ time: Date.now() })
    }
    filterCustom(value) {
        var result = true;
        result &= (this.state.filterForm.matricola === '' || this.state.filterForm.matricola.lenght <= 2 || value.matricola.includes(this.state.filterForm.matricola.value));
        result &= (this.state.filterForm.ragioneSociale === '' || this.state.filterForm.ragioneSociale.lenght <= 2 || value.ragioneSocialeSocieta.toLowerCase().includes(this.state.filterForm.ragioneSociale.value.toLowerCase()));

        //console.log('ragioneSociale filter:', this.state.filterForm.ragioneSociale.value.toLowerCase(), '|ragioneSociale value:', value.ragioneSocialeSocieta.toLowerCase(), '==>', result )
        return result;
    }

    ricerca = (event) => {
        this.refresh();
        this.forceRender();
    }

    static renderTable(forecasts, modifyFunction, deleteFunction, administrator, filterCustom) {
        return (

            <table className='table' >
                <thead>
                    <tr>
                        <th>Matricola</th>
                        <th>Ragione Sociale</th>
                        <th>PIVA</th>
                        <th>Indirizzo</th>
                        <th>IBAN</th>
                        <th>BIC</th>
                        {(administrator) && <th className="col-xs-1">Modifica</th>}
                        {(administrator) && <th className="col-xs-1">Elimina</th>}
                    </tr>
                </thead>
                <tbody>
                    {forecasts.filter(filterCustom)
                        .map(forecast =>
                            <tr key={forecast.id}>
                                <td>{forecast.matricola}</td>
                                <td>{forecast.ragioneSocialeSocieta}</td>
                                <td>{forecast.partitaIVA}</td>
                                <td>{forecast.cittaSocieta}: {forecast.indirizzoSocieta} n:{forecast.nCivicoSocieta}</td>
                                <td>{forecast.ibanSocieta}</td>
                                <td>{forecast.bicSwift}</td>
                                {(administrator) && <td><Button block bsSize="large" onClick={(event) => modifyFunction(event, forecast)} type="button" className="btn btn-warning btn-tables"><Glyphicon glyph='edit' /></Button></td>}
                                {(administrator) && <td><Button block bsSize="large" onClick={(event) => deleteFunction(event, forecast)} type="button" className="btn btn-danger btn-tables"><Glyphicon glyph='trash' /></Button></td>}
                            </tr>
                        )}
                </tbody>
            </table>
        );
    }
    render() {

        const formFilterElementsArray = [];
        for (let key in this.state.filterForm) {
            formFilterElementsArray.push({
                id: key,
                config: this.state.filterForm[key]
            });
        }
        let formFilter = (
            <div>
                <div className="row">
                    {formFilterElementsArray.map(formElement => (
                        <div className="col-sm-3" key={'div' + formElement.id}>
                            <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                touched={formElement.config.touched}
                                changed={(event) => this.filterFormChangeHandler(event, formElement.id)}
                                textdisabled={false} />
                        </div>
                    ))}
                </div>
            </div>
        );

        const formElementsArray = [];
        for (let key in this.state.objform) {
            formElementsArray.push({
                id: key,
                config: this.state.objform[key]
            });
        }
        let formInser = (
            <div>
                <form>
                    {formElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={true}
                            shouldValidate={true}
                            touched={true}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            textdisabled={(this.state.formsconfig.type === 3 || this.state.formsconfig.type === 2 && formElement.id === "matricola") ? true : false} />
                    ))}
                </form>
                <div className="row">
                    <div className="col-sm-6 btn-action">
                        {(this.state.formsconfig.type === 1) && <Button block bsSize="large" onClick={(event) => this.InserisciFetch(event)} type="button" className="btn btn-success btn-action">  Inserisci </Button>}
                        {(this.state.formsconfig.type === 2) && <Button block bsSize="large" onClick={(event) => this.ModificaFetch(event)} type="button" className="btn btn-warning btn-action">  Modifica </Button>}
                        {(this.state.formsconfig.type === 3) && <Button block bsSize="large" onClick={(event) => this.EliminaFetch(event)} type="button" className="btn btn-danger btn-action">  Elimina </Button>}
                    </div>
                    <div className="col-sm-6 btn-action">
                        <Button block bsSize="large" onClick={(event) => this.Chiudi(event)} type="button" className="btn btn-secondary btn-action">  Chiudi </Button>
                    </div>
                </div>
            </div>
        );
        let contents = this.state.loading
            ? <p className="col-sm-10"><em>Loading...</em></p>
            : Registry.renderTable(this.state.forecasts, this.Modifica, this.Elimina, (UserProfile.getLogin().level === -99), this.filterCustom,);

        return (
            <div>
                {(this.state.showerror == true) && <AlertElement strong={this.state.errorheader} message={this.state.errortext} clicked={(event) => this.clickdismiss(event)} />}
                <h1>Anagrafiche</h1>
                {formFilter}
                {(this.state.formsconfig.show === true) && formInser}
                {(this.state.formsconfig.show === false && UserProfile.getLogin().level === -99) &&
                    <Button block bsSize="large" onClick={(event) => this.Nuovo(event)} type="button" className="btn btn-success btn-action col-sm-6">  Nuova Anagrafica </Button>
                }
                <div className="col-sm-10">
                    <button onClick={(event) => this.ricerca(event)} type="button" className="btn btn-info">RICERCA</button>
                </div>
                <span></span>
                {contents}
            </div>
        );
    }
}
